/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as CommunicationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.communication.updateTemplate'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  id: /*#__PURE__*/ l.string(),
  name: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' }),
  ),
  contentMarkdown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  subject: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  updatedBy: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
  disabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<CommunicationDefs.TemplateView>(
    (() => CommunicationDefs.templateView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Administrative action to update an existing communication template. Allows passing partial fields to patch specific fields only. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'DuplicateTemplateName',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
